import React, { useEffect, useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Modal } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { useLocation } from 'react-router-dom';
import { IconSquareRoundedPlus } from '@tabler/icons-react';
import {
  DatatableRiskRegisterComp,
  CreateRiskRegisterComp,
  DatatableRiskProfile,
  CreateRiskProfileComp,
  EditRiskRegisterComp,
  EditRiskProfileComp,
  DatatableRiskManagementPlan,
  CreateRiskManagementPlanComp,
  CreateRiskManagementMonitoringComp,
  EditRiskManagementPlanComp,
  DatatableRiskManagementMonitoring,
  DatatableRiskManagementMonitoringReport,
  EditRiskManagementMonitoringComp,
  EditRiskManagementMonitoringReportComp,
} from '..';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { notifyApiError, notifyApiLoadError } from '../../../helpers/notifyApiError';

const DetailRiskRegisterComp = (props) => {
  // console.log(props);

  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const routeParams = useParams();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);
  const [lgShowUpdateProfile, setLgShowUpdateProfile] = useState(false);
  const [lgShowAddProfile, setLgShowAddProfile] = useState(false);
  const [lgShowAddMP, setLgShowAddMP] = useState(false);
  const [lgShowUpdateMP, setLgShowUpdateMP] = useState(false);
  const [lgShowAddMM, setLgShowAddMM] = useState(false);
  const [lgShowUpdateMM, setLgShowUpdateMM] = useState(false);
  const [lgShowUpdateReport, setLgShowUpdateReport] = useState(false);
  const [search, setSearch] = useState([]);
  const [searchProfil, setSearchProfil] = useState([]);
  const [searchMP, setSearchMP] = useState([]);
  const [searchMM, setSearchMM] = useState([]);
  const [searchReport, setSearchReport] = useState([]);
  const [filterData, setfilterData] = useState([]);
  const [filterProfil, setfilterProfil] = useState([]);
  const [filterManagementPlan, setfilterManagementPlan] = useState([]);
  const [filterManagementMonitoring, setfilterManagementMonitoring] = useState(
    []
  );
  const [
    filterManagementMonitoringReport,
    setfilterManagementMonitoringReport,
  ] = useState([]);
  const [oneRiskActivity, setoneRiskActivity] = useState([]);
  const [editRiskRegister, seteditRiskRegister] = useState([]);
  const [oneRiskProfile, setoneRiskProfile] = useState([]);
  const [editRiskProfile, seteditRiskProfile] = useState([]);
  const [oneRiskManagementPlan, setoneRiskManagementPlan] = useState([]);
  const [editRiskManagementPlan, seteditRiskManagementPlan] = useState([]);
  const [oneRiskManagementMonitoring, setoneRiskManagementMonitoring] =
    useState([]);
  const [
    oneRiskManagementMonitoringReport,
    setoneRiskManagementMonitoringReport,
  ] = useState([]);
  const [editRiskManagementMonitoring, seteditRiskManagementMonitoring] =
    useState([]);
  const [
    editRiskManagementMonitoringReport,
    seteditRiskManagementMonitoringReport,
  ] = useState([]);
  const [role, setRole] = useState('');

  const fetchOneRiskRegister = async () => {
    try {
      const options = {
        url: `/activity-targets/show/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setoneRiskActivity(data?.risk_registers);
      setfilterData(data?.risk_registers);
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-register/detail.fetchOneRiskRegister');
    }
  };

  const fetchOneRiskProfile = async () => {
    try {
      const options = {
        url: `/risk-profile/showByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setoneRiskProfile(data);
      setfilterProfil(data);
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-register/detail.fetchOneRiskProfile');
    }
  };

  const fetchOneRiskManagementPlan = async () => {
    try {
      const options = {
        url: `/management-plan/showByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setoneRiskManagementPlan(data);
      setfilterManagementPlan(data);
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-register/detail.fetchOneRiskManagementPlan');
    }
  };

  const fetchOneRiskManagementMonitoring = async () => {
    try {
      const options = {
        url: `/management-monitoring/showByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setoneRiskManagementMonitoring(data);
      setoneRiskManagementMonitoringReport(data);
      setfilterManagementMonitoring(data);
      setfilterManagementMonitoringReport(data);
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-register/detail.fetchOneRiskManagementMonitoring');
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-register/detail.fetchOneUser');
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-register/detail.fetchLoginStatus');
    }
  };

  const handleHapusRiskRegister = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/risk-register/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Risk Register Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchOneRiskRegister();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
              notifyApiError(err, { context: 'components/moleculs/risk-register/detail.handleHapusRiskRegister' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const handleHapusRiskProfile = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/risk-profile/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Risk Profil Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchOneRiskProfile();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
              notifyApiError(err, { context: 'components/moleculs/risk-register/detail.handleHapusRiskProfile' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const handleHapusRiskManagementPlan = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/management-plan/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Rencana Penanganan Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchOneRiskManagementPlan();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
              notifyApiError(err, { context: 'components/moleculs/risk-register/detail.handleHapusRiskManagementPlan' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const handleHapusRiskManagementMonitoring = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/management-monitoring/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Pemantauan Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchOneRiskManagementMonitoring();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
              notifyApiError(err, { context: 'components/moleculs/risk-register/detail.handleHapusRiskManagementMonitoring' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchOneUser();
    fetchOneRiskRegister();
    fetchOneRiskProfile();
    fetchOneRiskManagementPlan();
    fetchOneRiskManagementMonitoring();
  }, []);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleEditRiskRegister = (editRiskRegister) => {
    seteditRiskRegister(editRiskRegister);
    setLgShowUpdate(true);
  };

  const handleEditRiskProfile = (editRiskProfile) => {
    seteditRiskProfile(editRiskProfile);
    setLgShowUpdateProfile(true);
  };

  const handleEditRiskManagementPlan = (editRiskManagementPlan) => {
    seteditRiskManagementPlan(editRiskManagementPlan);
    setLgShowUpdateMP(true);
  };

  const handleEditRiskManagementMonitoring = (editRiskManagementMonitoring) => {
    seteditRiskManagementMonitoring(editRiskManagementMonitoring);
    setLgShowUpdateMM(true);
  };

  const handleEditRiskManagementMonitoringReport = (
    editRiskManagementMonitoringReport
  ) => {
    seteditRiskManagementMonitoringReport(editRiskManagementMonitoringReport);
    setLgShowUpdateReport(true);
  };

  const handleChangeSearchProfil = (text) => {
    setSearchProfil(text);
  };

  const handleChangeSearchMP = (text) => {
    setSearchMP(text);
  };

  const handleChangeSearchMM = (text) => {
    setSearchMM(text);
  };

  const handleChangeSearchReport = (text) => {
    setSearchReport(text);
  };

  useEffect(() => {
    const result = oneRiskActivity?.filter((item) => {
      let area = item.area;
      let causeOfTheIncident = item.causeOfTheIncident;
      let codeRisk = item.codeRisk;
      let riskFinancing = item.riskFinancing;

      return area
        .concat(causeOfTheIncident)
        .concat(codeRisk)
        .concat(riskFinancing)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setfilterData(result);
  }, [search]);

  useEffect(() => {
    const resultProfil = oneRiskProfile?.filter((item) => {
      let rootCause = item.rootCause;
      let controlStatus = item.controlStatus;

      return rootCause
        .concat(controlStatus)
        .toLowerCase()
        .match(searchProfil.toString().toLowerCase());
    });
    setfilterProfil(resultProfil);
  }, [searchProfil]);

  useEffect(() => {
    const resultMP = oneRiskManagementPlan?.filter((item) => {
      let action = item.action;
      let alternativeRiskManagement = item.alternativeRiskManagement;
      let frequency = item.frequency;
      let isEffective = item.isEffective;
      let pic = item.pic;
      let type = item.type;

      return action
        .concat(alternativeRiskManagement)
        .concat(frequency)
        .concat(isEffective)
        .concat(pic)
        .concat(type)
        .toLowerCase()
        .match(searchMP.toString().toLowerCase());
    });
    setfilterManagementPlan(resultMP);
  }, [searchMP]);

  useEffect(() => {
    const resultMM = oneRiskManagementMonitoring?.filter((item) => {
      let notYetHandled = item.notYetHandled;
      let improvementIdea = item.improvementIdea;
      let monitoringTime = item.monitoringTime;
      let monitoringCycle = item.monitoringCycle;
      let pic = item.pic;
      let riskLevel = item.riskLevel;

      return notYetHandled
        .concat(improvementIdea)
        .concat(monitoringTime)
        .concat(monitoringCycle)
        .concat(pic)
        .concat(riskLevel)
        .toLowerCase()
        .match(searchMM.toString().toLowerCase());
    });
    setfilterManagementMonitoring(resultMM);
  }, [searchMM]);

  useEffect(() => {
    const resultMR = oneRiskManagementMonitoringReport?.filter((item) => {
      let actionControl = item.actionControl;
      let riskHandlingOutput = item.riskHandlingOutput;
      let riskHandlingTarget = item.riskHandlingTarget;
      let riskHandlingRealization = item.riskHandlingRealization;
      let riskStatusTrend = item.riskStatusTrend;
      let riskStatusLevel = item.riskStatusLevel;

      return actionControl
        .concat(riskHandlingOutput)
        .concat(riskHandlingTarget)
        .concat(riskHandlingRealization)
        .concat(riskStatusTrend)
        .concat(riskStatusLevel)
        .toLowerCase()
        .match(searchReport.toString().toLowerCase());
    });
    setfilterManagementMonitoringReport(resultMR);
  }, [searchReport]);

  return (
    <>
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Kegiatan Sasaran dan Pemilik Risikonya
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <Table striped bordered hover>
                <thead className="bg-primary border-1 text-center text-white">
                  <tr>
                    <th width="300px">
                      <b>Nama Kegiatan</b>
                    </th>
                    <th width="500px">
                      <b>Tujuan Kegiatan (S.M.A.R.T)</b>
                    </th>
                    <th width="200px">
                      <b>Pemilik Risiko</b>
                    </th>
                  </tr>
                </thead>
                <tbody className="border-1">
                  <tr>
                    <td style={{ paddingLeft: '10px', containerStyle }}>
                      {props.itemRisk?.name}
                    </td>
                    <td style={containerStyle}>{props.itemRisk?.goals}</td>
                    <td style={{ textAlign: 'center' }}>
                      {props.itemRisk?.user?.jabatan}{' '}
                      {props.itemRisk?.user?.risk_division?.namaDivision}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Register Risiko
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="d-flex justify-content-between mb-5">
                <div></div>
                <div className="d-flex justify-content-between mb-5">
                  <button
                    onClick={() => setLgShowAdd(true)}
                    className="btn btn-sm btn-primary"
                  >
                    <IconSquareRoundedPlus stroke={2} /> Tambah Register Risiko
                  </button>
                </div>
              </div>
              <DatatableRiskRegisterComp
                riskRegister={filterData}
                detailriskActivity={props?.itemRisk}
                handleChangeSearch={handleChangeSearch}
                handleEditRiskRegister={handleEditRiskRegister}
                handleHapusRiskRegister={handleHapusRiskRegister}
              />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Profil Risiko
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div className="d-flex justify-content-between mb-5">
                <div></div>
                <div className="d-flex justify-content-between mb-5">
                  <button
                    onClick={() => setLgShowAddProfile(true)}
                    className="btn btn-sm btn-success"
                  >
                    <IconSquareRoundedPlus stroke={2} /> Tambah Profil Risiko
                  </button>
                </div>
              </div>
              <DatatableRiskProfile
                listRiskProfile={filterProfil}
                handleChangeSearchProfil={handleChangeSearchProfil}
                handleEditRiskProfile={handleEditRiskProfile}
                handleHapusRiskProfile={handleHapusRiskProfile}
              />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Rencana Penanganan Risiko
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div className="d-flex justify-content-between mb-5">
                <div></div>
                <div className="d-flex justify-content-between mb-5">
                  <button
                    onClick={() => setLgShowAddMP(true)}
                    className="btn btn-sm btn-info"
                  >
                    <IconSquareRoundedPlus stroke={2} /> Tambah Rencana
                    Penanganan
                  </button>
                </div>
              </div>
              <DatatableRiskManagementPlan
                listRiskManagement={filterManagementPlan}
                handleChangeSearchMP={handleChangeSearchMP}
                handleEditRiskManagementPlan={handleEditRiskManagementPlan}
                handleHapusRiskManagementPlan={handleHapusRiskManagementPlan}
              />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="true"
              aria-controls="collapseFive"
            >
              Pemantauan Pengendalian Risiko
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div className="d-flex justify-content-between mb-5">
                <div></div>
                <div className="d-flex justify-content-between mb-5">
                  <button
                    onClick={() => setLgShowAddMM(true)}
                    className="btn btn-sm btn-warning"
                  >
                    <IconSquareRoundedPlus stroke={2} /> Tambah Pemantauan
                    Risiko
                  </button>
                </div>
              </div>
              <DatatableRiskManagementMonitoring
                listRiskManagementMonitoring={filterManagementMonitoring}
                handleChangeSearchMM={handleChangeSearchMM}
                handleEditRiskManagementMonitoring={
                  handleEditRiskManagementMonitoring
                }
                handleHapusRiskManagementMonitoring={
                  handleHapusRiskManagementMonitoring
                }
              />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingEnam">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEnam"
              aria-expanded="true"
              aria-controls="collapseEnam"
            >
              Laporan Pemantauan
            </button>
          </h2>
          <div
            id="collapseEnam"
            class="accordion-collapse collapse"
            aria-labelledby="headingEnam"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div className="d-flex justify-content-between mb-5">
                {/* <div></div>
                <div className="d-flex justify-content-between mb-5">
                  <button
                    onClick={() => setLgShowAddProfile(true)}
                    className="btn btn-sm btn-danger"
                  >
                    <IconSquareRoundedPlus stroke={2} /> Tambah Laporan
                    Pemantauan
                  </button>
                </div> */}
              </div>
              <DatatableRiskManagementMonitoringReport
                listRiskManagementMonitoringReport={
                  filterManagementMonitoringReport
                }
                handleChangeSearchReport={handleChangeSearchReport}
                handleEditRiskManagementMonitoringReport={
                  handleEditRiskManagementMonitoringReport
                }
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Laporan Register Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateRiskRegisterComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchOneRiskRegister()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Ubah Register Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRiskRegisterComp
            editRiskRegister={editRiskRegister}
            close={() => setLgShowUpdate(false)}
            fetch={() => fetchOneRiskRegister()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowAddProfile}
        onHide={() => setLgShowAddProfile(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Profil Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateRiskProfileComp
            close={() => setLgShowAddProfile(false)}
            fetch={() => fetchOneRiskProfile()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdateProfile}
        onHide={() => setLgShowUpdateProfile(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Ubah Profil Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRiskProfileComp
            editRiskProfile={editRiskProfile}
            close={() => setLgShowUpdateProfile(false)}
            fetch={() => fetchOneRiskProfile()}
          />
        </Modal.Body>
      </Modal>

      {/* MP */}
      <Modal
        show={lgShowAddMP}
        onHide={() => setLgShowAddMP(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Rencana Penanganan Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateRiskManagementPlanComp
            close={() => setLgShowAddMP(false)}
            fetch={() => fetchOneRiskManagementPlan()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdateMP}
        onHide={() => setLgShowUpdateMP(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Ubah Rencana Penanganan Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRiskManagementPlanComp
            editRiskManagementPlan={editRiskManagementPlan}
            close={() => setLgShowUpdateMP(false)}
            fetch={() => fetchOneRiskManagementPlan()}
          />
        </Modal.Body>
      </Modal>

      {/* MM */}
      <Modal
        show={lgShowAddMM}
        onHide={() => setLgShowAddMM(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Pemantauan Pengendalian Risiko</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateRiskManagementMonitoringComp
            close={() => setLgShowAddMM(false)}
            fetch={() => fetchOneRiskManagementMonitoring()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdateMM}
        onHide={() => setLgShowUpdateMM(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">
              Form Edit Pemantauan Pengendalian Risiko
            </b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRiskManagementMonitoringComp
            editRiskManagementMonitoring={editRiskManagementMonitoring}
            close={() => setLgShowUpdateMM(false)}
            fetch={() => fetchOneRiskManagementMonitoring()}
          />
        </Modal.Body>
      </Modal>

      {/* Monitoring Report */}
      <Modal
        show={lgShowUpdateReport}
        onHide={() => setLgShowUpdateReport(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Laporan Pemantauan</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRiskManagementMonitoringReportComp
            editRiskManagementMonitoringReport={
              editRiskManagementMonitoringReport
            }
            close={() => setLgShowUpdateReport(false)}
            fetch={() => fetchOneRiskManagementMonitoring()}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DetailRiskRegisterComp;
